/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { DonationInfoResponse, DonationState, DonationSuccessResponse } from './types';
import { MutationRequestError, MutationRequestStatus } from '../types';

export const mutations: MutationTree<DonationState> = {
  dataLoading(state) {
    state.info = {
      status: MutationRequestStatus.LOADING,
      error: undefined,
      data: undefined,
    };
  },
  dataLoaded(state, payload: DonationInfoResponse) {
    state.info = {
      status: MutationRequestStatus.SUCCESS,
      error: undefined,
      data: payload,
    };
  },
  dataError(state, payload: MutationRequestError<null>) {
    state.info = {
      status: MutationRequestStatus.ERROR,
      error: payload,
      data: undefined,
    };
  },
  donationReset(state) {
    state.donation = {
      error: undefined,
      data: undefined,
      status: undefined,
    };
  },
  donationProcessing(state) {
    state.donation = {
      error: undefined,
      data: undefined,
      status: MutationRequestStatus.LOADING,
    };
  },
  donationProcessed(state, payload: DonationSuccessResponse) {
    state.donation = {
      error: undefined,
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  donationError(state, payload: MutationRequestError<null>) {
    state.donation = {
      error: payload,
      data: undefined,
      status: MutationRequestStatus.ERROR,
    };
  },
};
